import { createAction } from '@reduxjs/toolkit';
export const END_CONFERENCE_CALL_SESSION = 'END_CONFERENCE_CALL_SESSION';
export const endConferenceCallSessionAction = createAction(END_CONFERENCE_CALL_SESSION);